import { render, staticRenderFns } from "./F9.vue?vue&type=template&id=a510fd94&scoped=true"
import script from "./F9.vue?vue&type=script&lang=js"
export * from "./F9.vue?vue&type=script&lang=js"
import style0 from "./F9.vue?vue&type=style&index=0&id=a510fd94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a510fd94",
  null
  
)

export default component.exports